import * as rtk from "@reduxjs/toolkit";
const { createAction, createSlice } = { ...rtk }.default || rtk;
const hostStateName = "host";
const hostSlice = createSlice({
  name: hostStateName,
  initialState: {
    appId: void 0,
    appVersion: void 0,
    context: {}
  },
  reducers: {},
  extraReducers(builder) {
    builder.addCase(setHostInfoAction, (state, { payload }) => {
      state.appId = payload.appId;
      state.appVersion = payload.appVersion;
      state.context = payload.context;
    });
  }
});
const setHostInfoAction = createAction("ap/setHostInfo");
const { reducer: hostReducer } = hostSlice;
export {
  hostReducer,
  hostStateName,
  setHostInfoAction
};
//# sourceMappingURL=host.js.map
